var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ds--failure-retry",on:{"click":_vm.fnClick}},[_c('div',{staticClass:"retry-icon",style:(_vm.iconStyle)},[_c('svg-icon',{attrs:{"icon-class":_vm.svgIcon}})],1),_c('div',{staticClass:"retry-text",style:(_vm.textStyle)},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }